import { footerStyles } from "@insite/content-library/Pages/Footer";
import { css } from "styled-components";

footerStyles.page = {
    padding: 0,
    css: css`
        padding-bottom: 15px;
        background-color: black; // show black all the way to edge
    `,
};
